<template>
  <div class="detail" v-loading="loading">
    <div class="detailTop">
      <div class="web clearfix detailTopBox">
        <div class="fl">
          <div>
            <span class="job_name">{{ info.job_name }}</span>

            <span class="salary_package">
              {{ info.salary_package
              }}{{ info.salary_package === "面议" ? "" : "元/月" }}
            </span>
          </div>

          <div class="detailAny">
            <span>{{ info.school_name }}</span>

            <el-divider direction="vertical"></el-divider>

            <span>
              {{ info.province_name ? info.province_name : ""
              }}{{ info.city_name ? info.city_name : ""
              }}{{ info.dist_name ? info.dist_name : "" }}
            </span>

            <el-divider direction="vertical"></el-divider>

            <span>{{ info.work_experience }}</span>

            <el-divider direction="vertical"></el-divider>

            <span>{{ info.educational_require }}</span>

            <el-divider direction="vertical"></el-divider>

            <span>{{ info.sex_require }}</span>

            <el-divider direction="vertical"></el-divider>

            <span>{{ info.person_number }}</span>
          </div>

          <div class="detailBtn">
            <el-button
              type="primary"
              plain
              @click="beInterested"
              :icon="
                schoolInfo.focus === 1 ? 'el-icon-star-on' : 'el-icon-star-off'
              "
            >
              感兴趣
            </el-button>

            <el-button type="primary" plain @click="Delivery">
              投递简历
            </el-button>

            <el-button type="primary" @click="goChat">立即沟通</el-button>
          </div>
        </div>

        <div class="fr detailTopRight">
          <div v-if="info.school_label">
            <span
              class="school_label"
              v-for="(item, index) in info.school_label.filter((o, i) => i < 4)"
              :key="index"
            >
              {{ item }}
            </span>

            <el-popover placement="bottom-end" width="500" trigger="hover">
              <span
                class="school_label"
                v-for="(item, index) in info.school_label"
                :key="index"
              >
                {{ item }}
              </span>

              <span
                slot="reference"
                class="school_label"
                style="cursor: pointer"
                v-if="
                  info.school_label !== undefined &&
                  info.school_label.length > 4
                "
              >
                ...
              </span>
            </el-popover>
          </div>

          <div class="goResume">
            <el-link type="primary" icon="el-icon-tickets" @click="goResume">
              完善在线简历
            </el-link>

            <el-link
              type="primary"
              icon="el-icon-upload"
              style="margin-left: 30px"
              @click="openUpload"
            >
              新增附件简历
            </el-link>
          </div>
        </div>
      </div>
    </div>

    <div class="detailContent web">
      <div class="detailBox">
        <el-row :gutter="10">
          <el-col :span="18">
            <div class="detailLeft">
              <div class="school_avatar">
                <!-- <div>
                                    <el-avatar :size="60" :src="info.school_avatar"></el-avatar>
                                </div> -->

                <div>
                  {{ info.charge_name ? info.charge_name : info.school_name }}
                </div>
              </div>

              <div
                v-if="
                  info.skil_require !== undefined &&
                  info.skil_require.length > 0
                "
              >
                <h3 class="detailTitle">技能要求</h3>

                <div class="detailLabel">
                  <span v-for="(item, index) in info.skil_require" :key="index">
                    {{ item }}
                  </span>
                </div>
              </div>

              <div
                v-if="
                  info.designation_confim !== undefined &&
                  info.designation_confim.length > 0
                "
              >
                <h3 class="detailTitle">证书要求</h3>

                <div class="detailLabel">
                  <span
                    v-for="(item, index) in info.designation_confim"
                    :key="index"
                  >
                    {{ item }}
                  </span>
                </div>
              </div>

              <div v-if="info.job_description">
                <h3 class="detailTitle">职位描述</h3>

                <div class="detailText" v-html="info.job_description">
                  {{ info.job_description }}
                </div>
              </div>

              <div v-if="schoolInfo.desc">
                <h3 class="detailTitle">园所介绍</h3>

                <div class="detailText" v-html="schoolInfo.desc">
                  {{ info.desc }}
                </div>
              </div>

              <div>
                <h3 class="detailTitle">园所信息</h3>

                <div class="schoolDetail">
                  <div class="schoolDetailName">{{ schoolInfo.name }}</div>

                  <div class="schoolDetailBox">
                    <el-row :gutter="10">
                      <el-col :span="8" v-if="schoolInfo.charge_name">
                        <span class="schoolDetailTitle">负责人：</span>

                        <span>{{ schoolInfo.charge_name }}</span>
                      </el-col>

                      <el-col :span="8">
                        <span class="schoolDetailTitle">规模：</span>

                        <span>{{ schoolInfo.scale }}</span>
                      </el-col>

                      <el-col :span="8">
                        <span class="schoolDetailTitle">地区：</span>

                        <span>
                          {{
                            schoolInfo.province_name
                              ? schoolInfo.province_name
                              : ""
                          }}{{ schoolInfo.city_name ? schoolInfo.city_name : ""
                          }}{{
                            schoolInfo.dist_name ? schoolInfo.dist_name : ""
                          }}
                        </span>
                      </el-col>

                      <el-col :span="8">
                        <span class="schoolDetailTitle">机构类型：</span>

                        <span>
                          {{ company_typelist[schoolInfo.company_type] }}
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>

              <div v-if="schoolInfo.desc">
                <h3 class="detailTitle">工作地址</h3>

                <div class="school_address">
                  <div class="school_addressTitle">
                    <i class="el-icon-location-outline"></i>
                    {{ schoolInfo.address }}
                  </div>

                  <Amap
                    v-if="schoolInfo.longitude"
                    :longitude="schoolInfo.longitude"
                    :latitude="schoolInfo.latitude"
                  />
                </div>
              </div>

              <el-divider></el-divider>

              <div>
                <div
                  class="beSimilar"
                  v-if="beSimilarList !== undefined && beSimilarList.length > 0"
                >
                  <div class="beSimilarTitle">相似职位</div>

                  <div class="beSimilarBox">
                    <el-row :gutter="10">
                      <el-col
                        :span="8"
                        v-for="(item, index) in beSimilarList"
                        :key="index"
                        style="margin-bottom: 10px"
                      >
                        <el-card shadow="hover" :body-style="{ padding: '0' }">
                          <div class="beSimilarList" @click="goDetail(item)">
                            <div>
                              <el-image
                                style="width: 62px; height: 62px"
                                :src="item.school_avatar"
                                fit="cover"
                              />
                            </div>

                            <div class="beSimilarContent">
                              <div>{{ item.job_name }}</div>

                              <div class="salary_package">
                                {{ item.salary_package
                                }}{{
                                  item.salary_package === "面议" ? "" : "元/月"
                                }}
                              </div>

                              <div>
                                <span class="school_name textOverflow">
                                  {{ item.school_name }}
                                </span>

                                <el-divider direction="vertical"></el-divider>

                                <span class="school_name textOverflow">
                                  {{ item.city_name }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </el-card>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="6">
            <div class="otherPost">
              <el-card style="margin-bottom: 20px" shadow="hover">
                <div class="school" @click="goSchool">
                  <div class="school_avatar">
                    <el-avatar :size="60">
                      <img
                        :src="info.school_avatar"
                        style="width: 60px"
                        alt=""
                      />
                    </el-avatar>
                  </div>

                  <div class="school_name">{{ info.school_name }}</div>

                  <div class="goDetail">
                    招聘主页
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </el-card>

              <div class="otherPostTitle">手机查看</div>

              <div class="weChatCode">
                <img :src="weChatCode" alt="" />
              </div>

              <el-divider></el-divider>

              <div class="otherPostTitle">正在招聘的职位</div>

              <div
                class="otherPostBox"
                v-if="
                  schoolInfo.JobList !== undefined &&
                  schoolInfo.JobList.length > 0
                "
              >
                <div
                  class="otherPostList"
                  v-for="(item, index) in schoolInfo.JobList"
                  :key="index"
                  @click="goDetail(item)"
                >
                  <div>
                    <div>
                      <span class="job_name">{{ item.job_name }}</span>

                      <span class="salary_package">
                        {{ item.salary_package
                        }}{{ item.salary_package === "面议" ? "" : "元/月" }}
                      </span>
                    </div>

                    <div class="school_name textOverflow">
                      {{ item.school_name }}
                    </div>
                  </div>

                  <div>
                    <el-image
                      style="width: 62px; height: 62px"
                      :src="schoolInfo.avatar"
                      fit="cover"
                    />
                  </div>
                </div>
              </div>

              <div
                v-if="
                  schoolInfo.JobList !== undefined &&
                  schoolInfo.JobList.length === 0
                "
              >
                <noData imgWidth="70%" pad="10%" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 上传 -->

    <upload :uploadDialog="uploadDialog" @closeUpload="closeUpload" />
  </div>
</template>

<script>
import upload from "@/components/upload";
import { loginState } from "@/js/common";
import Amap from "@/components/map";
import noData from "@/components/noData";

export default {
  components: { upload, Amap, noData },
  watch: {
    $route() {
      this.jid = this.$route.query.jid;
      this.getDetail();
      this.getBeSimilar();
    },
  },
  data() {
    return {
      loading: true,
      jid: "",
      uploadDialog: false,
      info: {},
      beSimilarList: [],
      schoolInfo: {},
      company_typelist: ["幼儿园", "早教/托育机构", "综合教育公司", "其他"],
      weChatCode: "",
    };
  },
  mounted() {
    if (this.$route.query.jid) {
      this.jid = this.$route.query.jid;
      this.getDetail();
      this.getBeSimilar();
      this.getCode();
    }
  },
  methods: {
    // 二维码
    getCode() {
      let obj = {
        page: "jobjoin/pages/jobDetail/jobDetail",
        scene: "jid=" + this.jid,
      };
      this.api.get("/5d5f4eb649fda", obj).then((r) => {
        this.weChatCode = "data:image/png;base64," + r;
      });
    },
    // 感兴趣
    beInterested() {
      if (loginState()) {
        this.api
          .get("/5cfe7caab4a92", { sid: this.schoolInfo.sid })
          .then((r) => {
            this.schoolInfo.focus = this.schoolInfo.focus === 1 ? 0 : 1;
            this.$message({
              message: this.schoolInfo.focus === 1 ? "关注成功" : "取消关注",
              type: "success",
            });
          });
      } else {
        this.$router.push({ path: "/login" });
        this.$message({ message: "请先登录", type: "success" });
      }
    },
    // 投递
    Delivery() {
      if (loginState()) {
        this.api.get("/5cfe0bd997f6e", { jid: this.jid }).then((r) => {
          this.$message({ message: "投递成功", type: "success" });
        });
      } else {
        this.$router.push({ path: "/login" });
        this.$message({ message: "请先登录", type: "success" });
      }
    },
    // 立即沟通
    goChat() {
      if (this.Cookies.get("UserToken")) {
        this.$router.push({ path: "/chat", query: { jid: this.jid } });
      } else {
        this.$message({ message: "请先登录", type: "success" });
        this.$router.push({ path: "/login", query: { jid: this.jid } });
      }
    },
    // 获取职位详情
    getDetail() {
      this.api.get("/5cf08ebdab59e", { jid: this.jid }).then((r) => {
        this.info = r.data;
        if (this.info.skil_require) {
          this.info.skil_require = JSON.parse(this.info.skil_require);
        }
        if (this.info.designation_confim) {
          this.info.designation_confim = JSON.parse(
            this.info.designation_confim
          );
        }
        if (this.info.job_description) {
          this.info.job_description = this.info.job_description.replace(
            /↵/g,
            "<br>"
          );
          this.info.job_description = this.info.job_description.replace(
            /\n/g,
            "<br>"
          );
        }
        try {
          this.info.educational_require = JSON.parse(
            this.info.educational_require
          )[0];
        } catch (error) {
          this.info.educational_require = this.info.educational_require;
        }
        this.getSchool();
      });
    },
    // 获取园所详情
    getSchool() {
      this.loading = true;
      this.api.get("/5cfe6d594381a", { sid: this.info.sid }).then((r) => {
        this.schoolInfo = r.data;
        if (this.schoolInfo.desc) {
          this.schoolInfo.desc = this.schoolInfo.desc.replace(/↵/g, "<br />");
        }
        if (this.schoolInfo.JobList.length > 0) {
          this.schoolInfo.JobList = this.schoolInfo.JobList.filter(
            (o) => o.jid !== Number(this.jid)
          );
        }
        this.loading = false;
      });
    },
    // 获取相似职位
    getBeSimilar() {
      if (loginState()) {
        this.api.post("/624fdf1aacaad", { jid: this.jid }).then((r) => {
          this.beSimilarList = r.data.list;
        });
      }
    },
    // 去简历
    goResume() {
      if (loginState()) {
        this.$router.push({ path: "/job/resume" });
      } else {
        this.$router.push({ path: "/login" });
        this.$message({ message: "请先登录", type: "success" });
      }
    },
    // 关闭上传
    closeUpload(uploadDialog) {
      this.uploadDialog = uploadDialog;
    },
    // 打开上传
    openUpload() {
      if (loginState()) {
        this.uploadDialog = true;
      } else {
        this.$router.push({ path: "/login" });
        this.$message({ message: "请先登录", type: "success" });
      }
    },
    // 去职位详情
    goDetail(o) {
      this.loading = true;
      this.jid = o.jid;
      this.$router.push({ query: { jid: o.jid } });
      this.getDetail();
      this.getBeSimilar();
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    // 去园所详情
    goSchool() {
      this.$router.push({
        path: "/job/schoolDetail",
        query: { sid: this.info.sid },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detailTop {
  background: #444c60;
  padding: 24px 0;
  .detailTopBox {
    position: relative;
    > div {
      width: 50%;
    }
    .detailTopRight {
      text-align: right;
      .goResume {
        position: absolute;
        bottom: 10px;
        right: 0;
        font-size: 16px;
      }
    }
    .job_name {
      color: white;
      font-size: 32px;
      margin-right: 20px;
    }
    .salary_package {
      color: #fa6a43;
      font-size: 30px;
      font-weight: 600;
    }
    .detailAny {
      color: rgba(255, 255, 255, 0.7);
      padding-top: 10px;
      font-size: 14px;
    }
    .detailBtn {
      padding-top: 20px;
    }
  }
}
.school_label {
  padding: 0 15px;
  margin-right: 10px;
  margin-bottom: 10px;
  height: 23px;
  line-height: 23px;
  border-radius: 13px;
  border: 1px solid #ff5b12;
  color: #ff5b12;
  display: inline-block;
}
.detail {
  background: white;
  .detailBox {
    padding: 30px 0;
    .school_avatar {
      > div {
        display: inline-block;
        vertical-align: middle;
        font-size: 30px;
      }
      // >div:nth-child(2) {
      //     margin-left: 15px;
      // }
    }
    .detailTitle {
      padding-top: 20px;
      color: #424a5e;
      font-size: 15px;
    }
    .detailTitle::after {
      content: "";
      height: 2px;
      background: #ff5b12;
      width: 22px;
      display: block;
      margin-top: 10px;
    }
    .detailText {
      font-size: 14px;
      padding-top: 10px;
      line-height: 36px;
    }
    .detailLabel {
      padding-top: 10px;
      > span {
        border: 1px solid #ececec;
        color: rgba(153, 153, 153, 1);
        padding: 2px 8px;
        margin-right: 15px;
        margin-bottom: 10px;
        font-size: 14px;
      }
    }
    .schoolDetail {
      padding-top: 10px;
      .schoolDetailName {
        font-size: 14px;
      }
      .schoolDetailBox {
        padding-top: 10px;
        font-size: 14px;
        .schoolDetailTitle {
          color: #8d92a1;
        }
      }
    }
    .school_address {
      margin-top: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      .school_addressTitle {
        padding-left: 25px;
        color: #62687a;
        padding: 13px 15px 11px 35px;
      }
    }
  }
}
.beSimilar {
  .beSimilarBox {
    padding-top: 10px;
    .beSimilarList {
      padding: 15px;
      cursor: pointer;
      > div {
        display: inline-block;
        vertical-align: middle;
      }
      .beSimilarContent {
        width: 68%;
        margin-left: 10px;
        font-size: 14px;
        .salary_package {
          color: #fc703e;
        }
        .school_name {
          max-width: 80px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
}

.otherPost {
  .otherPostList {
    padding: 18px 0;
    border-bottom: 1px solid #f5f7f9;
    cursor: pointer;
    > div {
      display: inline-block;
      vertical-align: middle;
    }
    > div:nth-child(1) {
      width: 73%;
      margin-right: 3%;
    }
    .salary_package {
      color: #fc703e;
    }
    .school_name {
      color: #9fa3af;
      padding-top: 12px;
      width: 210px;
    }
  }
  .otherPostList:last-child {
    border-bottom: none;
  }
  .otherPostList:hover {
    .job_name {
      color: #fc703e;
    }
  }
}
.detailLeft {
  padding-right: 20px;
  border-right: 1px #f5f7f9 solid;
}
.school {
  cursor: pointer;
  position: relative;
  > div {
    display: inline-block;
    vertical-align: middle;
  }
  .school_name {
    width: 69%;
    margin-left: 3%;
  }
  .goDetail {
    position: absolute;
    right: 0;
    bottom: -17px;
    font-size: 14px;
    color: #999;
  }
}

.weChatCode {
  text-align: center;
  img {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/job/postDetail.vue